import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var font = variables.font;
export var text = /*#__PURE__*/css("float:left;font-size:", font.smallFontSize, ";line-height:", font.h3LineHeight, ";padding-right:8px;");